import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { LocaleService } from '@next/core-lib/i18n';
import { Environment } from 'src/environment';

export enum SwitchTranslateTypes {
  getText = 'getText',
  getKey = 'getKey',
}

@Injectable({
  providedIn: 'root',
})
export class SwitchTranslationService {
  private readonly env = inject<Environment>(EnvironmentInjector);
  private readonly locale = inject(LocaleService);

  private cartTranslateKey = 'cartTexts';
  private orderTranslateKey = 'orderTexts';

  get(key: string, type: SwitchTranslateTypes = SwitchTranslateTypes.getText) {
    if (type === SwitchTranslateTypes.getText) {
      return this.getTranslation(key);
    }
    return this.getKey(key);
  }

  private getKey(key: string) {
    const parentKey = this.env.CART_ENABLED ? this.cartTranslateKey : this.orderTranslateKey;
    return `${parentKey}.${key}`;
  }

  private getTranslation(key: string) {
    return this.locale.translate(this.getKey(key));
  }
}
